import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { ncbData } from '../../api';

const { FiRefreshCw, FiCloud, FiAlertCircle, FiCheckCircle } = FiIcons;
const FAMILY_TABLE = 'user_family_members_1749000000';

export default function LegacyChainSync({ onSynced }) {
  const [syncing, setSyncing] = useState(false);
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  const syncNetwork = async () => {
    setSyncing(true);
    setMessage('');
    setIsError(false);

    try {
      const members = [];
      let page = 1;
      let hasMore = true;

      while (hasMore) {
        const response = await ncbData('read', FAMILY_TABLE, { page, limit: 500 });
        if (response?.status !== 'success') {
          throw new Error(response?.error || 'Could not sync your family network.');
        }

        const pageMembers = Array.isArray(response?.data) ? response.data : [];
        members.push(...pageMembers);
        hasMore = response?.metadata?.hasMore === true;
        page += 1;
      }

      onSynced(members);
      setMessage(members.length
        ? `${members.length} saved ${members.length === 1 ? 'member' : 'members'} synced into the chain.`
        : 'No saved family-network members yet.');
    } catch (error) {
      setIsError(true);
      setMessage(error?.message || 'Could not sync your family network.');
    } finally {
      setSyncing(false);
    }
  };

  return (
    <section className="mb-6 flex flex-col gap-4 rounded-[28px] border border-brand-dark bg-white p-5 shadow-sm sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-start gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-accent-navy/10 text-accent-navy">
          <SafeIcon icon={FiCloud} className="h-5 w-5" />
        </div>
        <div>
          <h2 className="font-serif text-lg text-accent-navy">Family Network Sync</h2>
          <p className="mt-1 max-w-2xl text-xs leading-relaxed text-text-muted">
            Pull your saved family members into this graph. Sync reads your account’s Family Network; it does not change records.
          </p>
          {message && (
            <p className={`mt-2 flex items-center gap-1.5 text-xs ${isError ? 'text-red-700' : 'text-green-700'}`}>
              <SafeIcon icon={isError ? FiAlertCircle : FiCheckCircle} className="h-3.5 w-3.5" />
              {message}
            </p>
          )}
        </div>
      </div>
      <button
        type="button"
        onClick={syncNetwork}
        disabled={syncing}
        className="inline-flex shrink-0 items-center justify-center gap-2 rounded-xl bg-accent-navy px-4 py-3 text-[10px] font-black uppercase tracking-widest text-white transition hover:bg-accent-navy/90 disabled:cursor-wait disabled:opacity-60"
      >
        <SafeIcon icon={FiRefreshCw} className={`h-3.5 w-3.5 ${syncing ? 'animate-spin' : ''}`} />
        {syncing ? 'Syncing…' : 'Sync My Network'}
      </button>
    </section>
  );
}